import React, { useState, useEffect } from "react";
import { Card, Row, Input, Table, Select, Col, Button, Checkbox, Form, Spin, message } from "antd";
import { LeadManagementAdd } from "./LeadManagementAdd";
import { LeadManagementService } from "../services/LeadManagementService";
import { useId24 } from "../../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../../config/app-config";
import NumberFormat from "react-number-format";
import { TPagination, DataType, TDataLead, type ITsearch } from "../common";
import type { ColumnsType, TablePaginationConfig } from "antd/lib/table";

const appConfig = loadAppConfig();
const { Option } = Select;
export interface Props {
  accessRole: any;
  userprofile: any;
}

export const OverviewLeadManagement: React.FC<Props> = ({ accessRole, userprofile }): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState<{ count: number; data: DataType[] }>({ count: 0, data: [] });
  const [params, setParams] = useState<ITsearch>({
    accountNo: undefined,
    actionCode: undefined,
    cif: undefined,
    customerName: undefined,
    listName: undefined,
    noAction: undefined,
    User: { oaCode: undefined },
    onHold: false,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState<TPagination>({
    current: 1,
    pageSize: 10,
  });
  // masterdata
  const [listSelect, setlistSelect] = useState<object[]>([]);
  const [oaSelect, setOaSelect] = useState(Array);
  const [actionCodeSelect, setActionCodeSelect] = useState([]);
  // assign
  const [loadingAssign, setLoadingAssign] = useState<boolean>(false);

  useEffect(() => {
    fetchMasterData();
  }, []);

  useEffect(() => {
    if (loading) {
      fetchData();
    }
  }, [loading, params]);

  const fetchMasterData = async () => {
    const resultList = await LeadManagementService(apiBaseUrlDebt).getlistnameBytoken();
    const resultOa = await LeadManagementService(apiBaseUrlDebt).getOaSelect("");
    const resultActionCode = await LeadManagementService(apiBaseUrlDebt).getActionCodeSelect();
    setlistSelect(resultList);
    setActionCodeSelect(resultActionCode);
    setOaSelect(resultOa);
  };

  const fetchData = async () => {
    let dataSent: any = {
      skip: (Number(pagination.current) - 1) * Number(pagination.pageSize),
      take: Number(pagination.pageSize),
      ...params,
    };
    const response = await LeadManagementService(apiBaseUrlDebt).getDataForSearch(dataSent);
    const count = await LeadManagementService(apiBaseUrlDebt).getLeadCount({ ...params });
    setDataSource({ count: +count[0].cnt, data: response });
    setLoading(false);
  };
  const onSearch = (values: ITsearch) => {
    const { ...conditions } = values || {};
    let base: any = { ...conditions };
    if (values.onHold) {
      base = { ...conditions, onHold: values.onHold ?? false };
    }
    const normalized = Object.fromEntries(Object.entries(base).filter(([_, v]) => v !== undefined && v !== "" && v !== null));
    setParams(normalized as ITsearch);
    changePage({ current: 1, pageSize: 10 });
    setLoading(true);
  };
  const onclickHoldAssignData = async (conditions: any) => {
    const { oa, ...condition } = conditions || {};
    setLoadingAssign(true);
    const resultAssignHold = await LeadManagementService(apiBaseUrlDebt).assignHold({ condition }, params.onHold ?? false);
    if (resultAssignHold.count > 0) {
      message.success("Success");
    }
    changePage({ current: 1, pageSize: 10 });
    setLoadingAssign(false);
  };

  const onclickReCallAssignData = async (conditions: any) => {
    const { oa, UserId, ...condition } = conditions || {};
    setLoadingAssign(true);
    const resultAssignHold = await LeadManagementService(apiBaseUrlDebt).assignReCall({ condition, UserId });
    if (resultAssignHold.count > 0) {
      message.success("Success");
    }
    changePage({ current: 1, pageSize: 10 });
    setLoadingAssign(false);
  };

  const onclickAssignOaData = async (conditions: any) => {
    const { oa, adminOaId, ...condition } = conditions || {};
    setLoadingAssign(true);
    const resultAssignHold = await LeadManagementService(apiBaseUrlDebt).assignOa({ condition, adminOaId });
    if (resultAssignHold.count > 0) {
      message.success("Success");
    }
    changePage({ current: 1, pageSize: 10 });
    setLoadingAssign(false);
  };

  const checkAccessRole = (role: string) => {
    var result = accessRole.indexOf(role) > -1;
    if (result == true) {
      return true;
    } else {
      return false;
    }
  };

  const changePage = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPagination((prevState: TablePaginationConfig) => ({
      ...prevState,
      current: current || 1,
      pageSize: pageSize || 10,
    }));
    setLoading(true);
  };

  const columns: ColumnsType<any> = [
    {
      title: "CIF",
      dataIndex: "cif",
    },
    {
      title: "Account No.",
      dataIndex: "account_no",
    },
    {
      title: "List Name",
      dataIndex: "list_name_real",
    },
    {
      title: "Account Level",
      dataIndex: "account_level",
    },
    {
      title: "ชื่อลูกหนี้",
      dataIndex: "name",
      render: (value: string, row: TDataLead) => `${row.cust_name} ${row.cust_last_name}`,
    },
    {
      title: "Action Code",
      dataIndex: "action_code_id",
      render: (event: string) => (event ? event : "-"),
    },
    {
      title: "OS",
      dataIndex: "account_no",
      align: "right" as const,
      render: (text: string, record: TDataLead) => {
        if (!text) return null;
        const isLoan = record.channel === "LOAN";
        const isWriteOff = record.account_status === "W/O";
        const value = isLoan && isWriteOff ? record.closepayamt : record.overdue_amt;
        return <NumberFormat value={Number(value)} displayType="text" decimalScale={2} fixedDecimalScale thousandSeparator />;
      },
    },
    {
      title: "OA",
      dataIndex: "oa_name",
    },
    {
      title: "No Action (days)",
      dataIndex: "noactiondate",
    },
  ];

  return (
    <Spin tip="กรุณารอสักครู่..." spinning={loading}>
      <Spin tip="กำลังดำเนินการ Assign..." spinning={loadingAssign}>
        <Row style={{ width: "100%", marginTop: "2rem" }}>
          <Col span={checkAccessRole("ddebtLeadManagementAssignto") ? 18 : 24} style={{ paddingRight: "10px" }}>
            <Card style={{ width: "100%", textAlign: "left" }} title={"กำหนดเงื่อนไขในการค้นหาข้อมูล"}>
              <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                <Form<ITsearch>
                  form={form}
                  layout="vertical"
                  onFinish={onSearch}
                  initialValues={{
                    onHold: false,
                  }}
                >
                  <Row>
                    <Col span={6} style={{ paddingLeft: "10px", paddingRight: "10px" }} xs={12} md={8} lg={6}>
                      <Form.Item<ITsearch> label="List" name="listName">
                        <Select
                          placeholder="Please Select"
                          allowClear
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input: any, option: any) => option.children.toString().toLowerCase().includes(input.toLowerCase())}
                        >
                          <Option key="0" value="" disabled>
                            <em
                              style={{
                                fontStyle: "normal",
                                color: "#C8C8C8",
                              }}
                            >
                              {`Please Select`}
                            </em>
                          </Option>
                          {listSelect.map((opt: any, num: any) => {
                            return (
                              <Option key={num + 1} value={opt}>
                                {opt}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6} style={{ paddingLeft: "10px", paddingRight: "10px" }} xs={12} md={8} lg={6}>
                      <Form.Item<ITsearch> label="OA" name="oa">
                        <Select
                          placeholder="Please Select"
                          allowClear
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input: any, option: any) => option.children.toString().toLowerCase().includes(input.toLowerCase())}
                        >
                          {oaSelect.map((oa: any, num: number) => {
                            return (
                              <Option value={oa.oa_code} key={num + 1}>
                                {oa.oa_name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6} style={{ paddingLeft: "10px", paddingRight: "10px" }} xs={12} md={8} lg={6}>
                      <Form.Item<ITsearch> label="Action Code" name="actionCode">
                        <Select placeholder="Please Select" allowClear>
                          {actionCodeSelect.map((action: any) => (
                            <Option value={action.actionCode} key={action.actionCode}>
                              {action.actionName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6} style={{ paddingLeft: "10px", paddingRight: "10px" }} xs={12} md={8} lg={6}>
                      <Form.Item<ITsearch> label="No Action" name="noAction">
                        <Input style={{ width: "100%" }} placeholder="Number of Day" type="number" />
                      </Form.Item>
                    </Col>
                    <Col span={6} style={{ paddingLeft: "10px", paddingRight: "10px" }} xs={12} md={8} lg={6}>
                      <Form.Item<ITsearch> label="CIF" name="cif">
                        <Input placeholder="Text" />
                      </Form.Item>
                    </Col>
                    <Col span={6} style={{ paddingLeft: "10px", paddingRight: "10px" }} xs={12} md={8} lg={6}>
                      <Form.Item<ITsearch> label="Account No." name="accountNo">
                        <Input placeholder="Text" />
                      </Form.Item>
                    </Col>
                    <Col span={6} style={{ paddingLeft: "10px", paddingRight: "10px" }} xs={12} md={8} lg={6}>
                      <Form.Item<ITsearch> label="ชื่อลูกหนี้" name="customerName">
                        <Input placeholder="Text" />
                      </Form.Item>
                    </Col>
                    <Col
                      span={6}
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingTop: "30px",
                      }}
                      xs={12}
                      md={8}
                      lg={6}
                    >
                      <Form.Item name="onHold" valuePropName="checked" wrapperCol={{ offset: 8, span: 16 }}>
                        <Checkbox>{`On hold`}</Checkbox>
                      </Form.Item>
                    </Col>
                    <Col
                      span={6}
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingTop: "30px",
                      }}
                      xs={12}
                      md={8}
                      lg={6}
                    >
                      <Form.Item>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{
                            marginLeft: "10px",
                          }}
                        >
                          {`Search`}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Card>
            <Card style={{ marginTop: "15px", width: "100%" }}>
              <Table
                size="small"
                columns={columns}
                dataSource={dataSource.data}
                loading={loading}
                scroll={{ x: "calc(500px + 100%)" }}
                pagination={{ total: dataSource.count, current: pagination.current, pageSize: pagination.pageSize }}
                onChange={changePage}
                rowKey={"id"}
              />
            </Card>
          </Col>
          {checkAccessRole("ddebtLeadManagementAssignto") ? (
            <Col span={6}>
              <LeadManagementAdd
                userprofile={userprofile}
                oaSelect={oaSelect}
                conditionAssign={params}
                loading={loading}
                setLoading={setLoading}
                onclickHoldAssignData={onclickHoldAssignData}
                onclickReCallAssignData={onclickReCallAssignData}
                onclickAssignOaData={onclickAssignOaData}
              />
            </Col>
          ) : (
            <></>
          )}
        </Row>
      </Spin>
    </Spin>
  );
};
